import routes from './routes';
import getItemInformation from '../content/commerce/items';

export default () => routes.reduce(
  (
    acc,
    route,
  ) => {
    const {
      path,
      meta = {},
      noSitemap,
      props,
      itemRoute,
    } = route;
    let {
      breadcrumbs,
    } = route;
    if (itemRoute) {
      const {
        routeDef,
      } = getItemInformation(props.varenr);
      breadcrumbs = routeDef.breadcrumbs; // eslint-disable-line
    }
    if (!breadcrumbs || noSitemap) {
      return acc;
    }
    if (path.indexOf(':') !== -1) {
      return acc;
    }
    const {
      base,
      title,
    } = breadcrumbs;
    let incrementer = acc;
    for (let i = 0; i < base.length; i += 1) {
      const {
        props: {
          link,
          title: baseTitle,
        },
      } = base[i];
      let existingChild = incrementer.children.find(({ title: title2, link: link2 }) => title2 === baseTitle && link === link2);
      if (!existingChild) {
        existingChild = {
          link,
          title: baseTitle,
          children: [],
        };
        incrementer.children.push(existingChild);
      }
      incrementer = existingChild;
    }
    if (title) {
      incrementer.children.push(
        {
          link: path,
          title,
          children: [],
          metaTitle: meta.title,
        },
      );
    } else {
      incrementer.metaTitle = meta.title;
    }
    return acc;
  },
  { children: [] },
);
